// extracted by mini-css-extract-plugin
export default {"modalErrorMessage":"styles_modalErrorMessage__0jn5S","modalTitle":"styles_modalTitle__rt2Kz"};